import { getElementLabel } from './ElementPlugin'

const LabelMakerPlugin = options => {
  const prefixMap = {}

  return {
    commands: {
      registerLabelPrefix(editor, type, prefix = 'q') {
        if (!prefixMap.hasOwnProperty(prefix)) {
          prefixMap[prefix] = [type]
        }

        if (!prefixMap[prefix].includes(type)) {
          prefixMap[prefix].push(type)
        }
      }
    },
    queries: {
      getNextLabelText(editor, currentLabelText, type) {
        const { nodes } = editor.value.document
        const currentPrefix = Object.keys(prefixMap).find(k =>
          currentLabelText.match(new RegExp(`^${k}\\d+$`))
        )
        const prefix = Object.keys(prefixMap).find(k =>
          prefixMap[k].includes(type)
        )

        const isCustomLabel = !currentPrefix && currentLabelText
        const isSamePrefix =
          currentPrefix !== undefined && currentPrefix === prefix

        // We shouldn't muck around with the label if the user has changed
        // it to a non standard prefix or if the new type has the same prefix
        if (isCustomLabel || isSamePrefix) {
          return currentLabelText
        }

        // Count up labels that match our prefix and generate the next label
        const prefixRegExp = new RegExp(`^${prefix}\\d+$`)
        const labelMax =
          nodes
            .filter(node => prefixMap[prefix].includes(node.type))
            .map(node => getElementLabel(node).text)
            .filter(label => label.match(prefixRegExp))
            .map(label => parseInt(label.slice(prefix.length), 10))
            .max() + 1
        return `${prefix}${labelMax ? labelMax : 1}`
      }
    }
  }
}

export default LabelMakerPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/LabelMakerPlugin.js